import customTabbar from "@/components/customTabbar/customTabbar.vue";
import customNav from "@/components/customNav/customNav.vue";
import customBanner from "@/components/customBanner/customBanner.vue";
import customArticle from "@/components/customArticle/customArticle.vue";
import customShare from "@/components/customShare/customShare.vue";
import customCityCascader from "@/components/customCityCascader/customCityCascader.vue";
import customCategory from "@/components/customCategory/customCategory.vue";
import customProduct from "@/components/customProduct/customProduct.vue";
import customUploader from "@/components/customUploader/index.vue";

export default {
    install(Vue) {
        Vue.component("customTabbar", customTabbar);
        Vue.component("customNav", customNav);
        Vue.component("customBanner", customBanner);
        Vue.component("customArticle", customArticle);
        Vue.component("customShare", customShare);
        Vue.component("customCityCascader", customCityCascader);
        Vue.component("customCategory", customCategory);
        Vue.component("customProduct", customProduct);
        Vue.component("CustomUploader", customUploader);
    },
};

